import createHttpError, { HttpError } from 'http-errors';

import { PhoneConfig } from '@/models';

import { getApiHeaders, getSessionId, getVid } from './apiHeaders';

export const fetchPhoneFromPool = async (): Promise<PhoneConfig | undefined> => {
  try {
    const vid = getVid();
    if (!vid || !getSessionId()) {
      return;
    }

    const fetchUrl = `/home-solar/api/v1/inp/visitor/available-phone`;
    const response = await fetch(fetchUrl, {
      method: 'POST',
      headers: getApiHeaders(),
      body: JSON.stringify({ vid }),
    });

    if (!response.ok) {
      const { status, statusText } = response;
      throw createHttpError(status, (await response.text()) || statusText);
    }

    return await response.json();
  } catch (err) {
    const httpError = err as HttpError;
    // Suppress transient infrastructure errors that the app gracefully handles via DEFAULT_PHONE fallback and retry
    // HACK suppress 580 errors caused by Australian visitors during Aug 8-11, 2025
    if ([401, 502, 580].includes(httpError.status)) {
      return;
    }

    throw err;
  }
};
